import haversine from 'haversine';

export type LatLon = { lat: number; lon: number };

export const haversineDistance = (a: LatLon, b: LatLon): number =>
    haversine(a, b, { format: '{lon,lat}', unit: 'km' });
